import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import Marquee from 'react-fast-marquee';

const Arrow = ({ down = true }) => {
    return (
        <svg
            className={!down && 'rotate-180'}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.66026 5.5L10.3371 5.5C10.5218 5.49973 10.7027 5.55225 10.859 5.65148C11.0153 5.75071 11.1406 5.89259 11.2203 6.06071C11.3136 6.26018 11.3496 6.4821 11.324 6.70119C11.2985 6.92027 11.2125 7.12772 11.0759 7.29987L8.73744 10.1595C8.64567 10.2664 8.53222 10.3521 8.40476 10.4108C8.2773 10.4696 8.13882 10.5 7.9987 10.5C7.85858 10.5 7.7201 10.4696 7.59264 10.4108C7.46518 10.3521 7.35172 10.2664 7.25995 10.1595L4.92152 7.29987C4.78488 7.12772 4.69889 6.92027 4.67335 6.70119C4.64782 6.4821 4.68377 6.26017 4.7771 6.06071C4.85683 5.89259 4.9821 5.75071 5.13839 5.65148C5.29469 5.55225 5.47563 5.49973 5.66026 5.5Z"
                fill={down ? '#FDA29B' : '#6CE9A6'}
            />
        </svg>
    );
};

const JncCryptoTicker = () => {
    const cryptoData = useSelector(state => state.juno.cryptoStats);
    const { getCryptoData } = useJunoCommonFunctions();

    useEffect(() => {
        getCryptoData();
    }, []);

    return (
        <Marquee autoFill={true} pauseOnHover={true} speed={30} style={{ background: '#000' }}>
            <div className="flex justify-evenly bg-black text-white px-6 py-2.5 shadow-md gap-16 min-h-[40px] text-sm leading-tight">
                {cryptoData?.length
                    ? cryptoData.map(crypto => (
                          <div key={crypto.symbol} className="flex items-center space-x-1 shrink-0">
                              <span className="text-gray-200 font-medium">{crypto.name}</span>
                              <span className="text-gray-400 uppercase font-normal">
                                  ({crypto.symbol})
                              </span>
                              <span
                                  className={`flex items-center text-sm font-medium ${
                                      crypto.price_change_percentage_24h >= 0
                                          ? 'text-emerald-300'
                                          : 'text-red-300'
                                  }`}>
                                  {crypto.price_change_percentage_24h >= 0 ? (
                                      <Arrow down={false} />
                                  ) : (
                                      <Arrow />
                                  )}
                                  {Math.abs(crypto.price_change_percentage_24h).toFixed(1)}%
                              </span>
                          </div>
                      ))
                    : null}
            </div>
        </Marquee>
    );
};

export default JncCryptoTicker;
